import { getUserFullName } from '@/services/helpers/strings';

import {
  type PosCredListInterface,
  type PosCreditsServerInterface
} from '../type';

export const posCredListAdapter = (
  data: PosCreditsServerInterface['data']
): PosCredListInterface[] => {
  return data.map((item) => ({
    createdDate: item?.create_date || null,
    fullName: getUserFullName(item.client, { pattern: 'first_last' }),
    loanAmount: item?.loan_amount || null,
    phone: item.client?.phone_number || null,
    product: item?.product?.name || null,
    uuid: item?.uuid,
    status: item?.status || null,
    bankResponse: item?.responses || null,
    dealer: item?.dealer?.name || null,
    userName: getUserFullName(item.user, { pattern: 'first_last' })
  }));
};
